<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        :model="dataForm"
        label-width="120px"
        :rules="editFormRules"
      >
        <el-form-item
          label="基础信息"
          style="background-color: #f8f8f9"
          label-width="80px"
        >
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名：" prop="Name">
              <el-input
                placeholder="请输入姓名"
                v-model="dataForm.Name"
                clearable
                maxlength="50"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别：">
              <el-radio v-model="dataForm.Sex" :label="0">女</el-radio>
              <el-radio v-model="dataForm.Sex" :label="1">男</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="民族：">
              <el-select v-model="dataForm.National" placeholder="请选择">
                <el-option
                  v-for="item in Nation"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="国籍：" prop="Nationality">
              <el-input
                placeholder="请输入国籍"
                v-model="dataForm.Nationality"
                clearable
                maxlength="50"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="籍贯：" prop="NationPlace">
              <el-select v-model="dataForm.NationPlace" placeholder="请选择">
                <el-option
                  v-for="item in NativePlace"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职业："
              ><el-input
                placeholder="请输入职业"
                v-model="dataForm.Perfessional"
                clearable
                maxlength="50"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="证件类型：">
              <el-select v-model="dataForm.IdType" placeholder="请选择">
                <el-option
                  v-for="item in idType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件号码：" prop="IdentityCard">
              <el-input
                placeholder="请输入证件号码"
                v-model="dataForm.IdentityCard"
                clearable
                maxlength="50"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学历：">
              <el-select v-model="dataForm.Education" placeholder="请选择">
                <el-option
                  v-for="item in StemEducation"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="手机号码：" prop="Phone"
              ><el-input
                placeholder="请输入手机号码"
                v-model="dataForm.Phone"
                clearable
                maxlength="50"
              /> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="QQ号码："
              ><el-input
                placeholder="请输入QQ号码"
                v-model="dataForm.QQNo"
                clearable
                maxlength="50"
              /> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="微信号："
              ><el-input
                placeholder="请输入微信号"
                v-model="dataForm.WeChatNo"
                clearable
                maxlength="50"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="身高(CM)："
              ><el-input
                placeholder="请输入身高(CM)"
                v-model="dataForm.Height"
                clearable
                maxlength="20"
              /> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="体重(KG)："
              ><el-input
                placeholder="请输入体重(KG)"
                v-model="dataForm.Weight"
                clearable
                maxlength="20"
              /> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="血型：" prop="BloodType">
              <el-select v-model="dataForm.BloodType" placeholder="请选择">
                <el-option
                  v-for="item in bloodType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="电子邮箱："
              ><el-input
                placeholder="请输入电子邮箱"
                v-model="dataForm.Email"
                clearable
                maxlength="50"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="无偿献血次数："
              ><el-input
                placeholder="请输入无偿献血次数"
                v-model="dataForm.BloodDonation"
                clearable
                maxlength="20"
              /> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="是否愿意参加志愿者服务：" label-width="200px">
              <el-radio v-model="dataForm.IsVolunteer" :label="1">是</el-radio>
              <el-radio v-model="dataForm.IsVolunteer" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="户籍所在地址：" prop="DomicilePlace"
              ><el-input
                placeholder="请输入户籍所在地址"
                v-model="dataForm.DomicilePlace"
                clearable
                maxlength="100"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="经常居住地：" prop="Address"
              ><el-input
                placeholder="请输入经常居住地"
                v-model="dataForm.Address"
                clearable
                maxlength="100"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="工作单位/学校："
              ><el-input
                placeholder="请输入工作单位/学校"
                v-model="dataForm.WorkUnit"
                clearable
                maxlength="100"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="单位/学校地址："
              ><el-input
                placeholder="请输入单位/学校地址"
                v-model="dataForm.School"
                clearable
                maxlength="100"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="单位/学校电话："
              ><el-input
                placeholder="请输入单位/学校电话"
                v-model="dataForm.ContactPhone"
                clearable
                maxlength="50"
              /> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注："
              ><el-input
                placeholder="请输入备注"
                type="textarea"
                :rows="3"
                v-model="dataForm.Content"
                clearable
                maxlength="100"
              /> </el-form-item
          ></el-col>
        </el-row>
        <div v-for="(item, i) in dataForm.Relations" :key="i">
          <el-form-item
            label="亲友信息"
            style="background-color: #f8f8f9"
            label-width="80px"
          >
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="姓名："
                :prop="`Relations[${i}].Name`"
                :rules="{
                  required: true,
                  message: '请输入姓名',
                  trigger: 'blur',
                }"
                ><el-input
                  placeholder="请输入姓名"
                  v-model="item.Name"
                  clearable
                  maxlength="100"
                /> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item
                label="关系代码："
                :prop="`Relations[${i}].RelationCode`"
                :rules="{
                  required: true,
                  message: '请选择关系代码',
                  trigger: 'blur',
                }"
              >
                <el-select v-model="item.RelationCode" placeholder="请选择">
                  <el-option
                    v-for="code in relationCode"
                    :key="code.value"
                    :label="code.label"
                    :value="code.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="手机号："
                :prop="`Relations[${i}].Phone`"
                :rules="{
                  required: true,
                  message: '请输入手机号',
                  trigger: 'blur',
                }"
                ><el-input
                  placeholder="请输入手机号"
                  v-model="item.Phone"
                  clearable
                  maxlength="100"
                /> </el-form-item
            ></el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="固定电话："
                ><el-input
                  placeholder="请输入固定电话"
                  v-model="item.FixPhone"
                  clearable
                  maxlength="100"
                /> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item label="微信号："
                ><el-input
                  placeholder="请输入固定电话"
                  v-model="item.WechatNo"
                  clearable
                  maxlength="100"
                /> </el-form-item
            ></el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="联系地址："
                prop="Address"
                :rules="{
                  required: true,
                  message: '请输入联系地址',
                  trigger: 'blur',
                }"
                ><el-input
                  placeholder="请输入联系地址"
                  v-model="item.Address"
                  clearable
                  maxlength="100"
                /> </el-form-item
            ></el-col>
          </el-row>
        </div>
        <el-form-item
          label="送样信息"
          style="background-color: #f8f8f9"
          label-width="80px"
        >
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="送样批次：" prop="SampleBatch"
              ><el-input
                placeholder="送样批次"
                v-model="dataForm.SampleBatch"
                clearable
                maxlength="10"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="送样编号：" prop="SampleNo"
              ><el-input
                placeholder="送样编号"
                v-model="dataForm.SampleNo"
                clearable
                maxlength="10"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="采样日期：" prop="SamplingTime"
              ><el-date-picker
                v-model="dataForm.SamplingTime"
                type="date"
                value-format="timestamp"
                placeholder="选择日期"
              ></el-date-picker> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="送样日期：" prop="SendSampleTime"
              ><el-date-picker
                v-model="dataForm.SendSampleTime"
                type="date"
                value-format="timestamp"
                placeholder="选择日期"
              ></el-date-picker> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="是否填报名表：" prop="IsApply"
              ><el-radio v-model="dataForm.IsApply" :label="true">是</el-radio>
              <el-radio v-model="dataForm.IsApply" :label="false">否</el-radio>
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="血样管数量2支：" prop="IsBloodSample"
              ><el-radio v-model="dataForm.IsBloodSample" :label="true"
                >是</el-radio
              >
              <el-radio v-model="dataForm.IsBloodSample" :label="false"
                >否</el-radio
              >
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="状态：" prop="MatchingStatue"
              ><el-select v-model="dataForm.MatchingStatue" placeholder="状态">
                <el-option
                  v-for="item in MatchingStatue"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  clearable
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editFormRules: {
        SampleBatch: {
          required: true,
          message: "请输入送样批次",
          trigger: "blur",
        },
        SampleNo: {
          required: true,
          message: "请输入送样编号",
          trigger: "blur",
        },
        SamplingTime: {
          required: true,
          message: "请选择采样日期",
          trigger: "blur",
        },
        SendSampleTime: {
          required: true,
          message: "请选择送样日期",
          trigger: "blur",
        },
        MatchingStatue: {
          required: true,
          message: "请选择状态",
          trigger: "blur",
        },
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        Phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        IdentityCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "身份证格式不正确",
            trigger: "blur",
          },
        ],
        NationPlace: [
          { required: true, message: "请输入籍贯", trigger: "blur" },
        ],
        Nationality: [
          { required: true, message: "请输入国籍", trigger: "blur" },
        ],
        // idType: [
        //   { required: true, message: '证件类型', trigger: 'blur' }
        // ],
        BloodType: [
          { required: true, message: "请输入血型", trigger: "change" },
        ],
        DomicilePlace: [
          { required: true, message: "请输入户籍所在地", trigger: "blur" },
        ],
        Address: [
          { required: true, message: "请输入经常居住地", trigger: "blur" },
        ],
      },
      formTitle: "造血干细胞捐献志愿者登记信息",
      isConfirm: false,
      width: "85%",
      dataForm: {
        IsVolunteer: 1,
        Sex: 0,
        IsBloodSampl: true,
        IsApply: true,
        Relations: [
          {
            Name: "",
            RelationCode: "",
            Phone: "",
            FixPhone: "",
            WechatNo: "",
            Address: "",
          },
          {
            Name: "",
            RelationCode: "",
            Phone: "",
            FixPhone: "",
            WechatNo: "",
            Address: "",
          },
        ],
      },
      MatchingStatue: [
        { value: 0, label: "采血样" },
        { value: 1, label: "入库" },
        { value: 2, label: "筛选" },
        { value: 3, label: "高分辨" },
        { value: 4, label: "体检" },
        { value: 5, label: "捐献成功" },
      ],
    };
  },
  components: {
    OfDialog,
  },
  computed: {
    showSex() {
      return (data) => {
        return data == 0 ? "女" : "男";
      };
    },
    showMatchingStatue() {
      return (data) => {
        switch (data) {
          case 0:
            return "采血样";
          case 1:
            return "入库";
          case 2:
            return "筛选";
          case 3:
            return "高分辨";
          case 4:
            return "体检";
          case 5:
            return "捐献成功";
        }
      };
    },
    showIsVolunteer() {
      return (data) => {
        return data == 0 ? "否" : "是";
      };
    },
  },
  mounted() {},
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //提交
    confirm() {
      let that = this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.isConfirm = true;
          let params = Object.assign({}, that.dataForm);
          params.SamplingTime = params.SamplingTime / 1000;
          params.SendSampleTime = params.SendSampleTime / 1000;
          api
            .SaveDonationStemCell(params)
            .then((res) => {
              if (res.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
              that.isConfirm = false;
            })
            .catch((e) => {
              this.$message({
                message: e.toString(),
                type: "error",
              });
              that.isConfirm = false;
            });
        }
      });
    },
  },
};
</script>

<style  scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-form >>> .el-date-editor {
  width: 292.3px;
}
.el-form >>> .el-select {
  width: 292.3px;
}
.el-form >>> .el-form-item__label {
  font-weight: 500;
}
</style>
